{
  "nl": {
    "published": {
      "labels": {
        "publishedCustomerPartners": "Gepubliceerd voor klanten en partners",
        "publishedCustomer": "Gepubliceerd voor klanten",
        "publishedPartners": "Gepubliceerd voor partners",
        "notPublished": "Niet gepubliceerd"
      },
      "publish_mode": {
        "inherit": "Sjabloon volgen",
        "inherit_info": "Behoud de gepubliceerde of niet-gepubliceerde status van elk item uit het sjabloon",
        "publish": "Publiceren voor klanten",
        "publish_info": "Klanten zien deze meteen",
        "title": "Publiceren",
        "unpublished": "Aanmaken zonder te publiceren",
        "unpublished_info": "Verborgen voor klanten tot je ze publiceert"
      }
    }
  }
}
